import { render, staticRenderFns } from "./TheHeaderDropdownLang.vue?vue&type=template&id=1f956d31&scoped=true"
import script from "./TheHeaderDropdownLang.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownLang.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownLang.vue?vue&type=style&index=0&id=1f956d31&prod&scoped=true&lang=css"
import style1 from "./TheHeaderDropdownLang.vue?vue&type=style&index=1&id=1f956d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f956d31",
  null
  
)

export default component.exports